import { Typography } from 'antd';
import { Form, usePaging, BaseInfoContent, SubContent } from '@maxtropy/components';
import React, { useEffect, useMemo, useState } from 'react';
import { EdgeDeviceData, formItemsDisplayByType } from './factory';
import EdgeDevicePointDetail from '../EdgeDevicePointInfo/Detail';
import { EdgeDeviceTemplatePoint } from '../EdgeDevicePointInfo';
import { SearchParams } from '../EdgeDevicePointInfo/mockingbird/Detail';
import { IotProtocolType } from '../../types';
import useIsGateway from '../../hooks/useIsGateway';
import { Link } from 'react-router-dom';

interface SharedEdgeTemplateDetailProps {
  data?: EdgeDeviceData;
  dataSource: EdgeDeviceTemplatePoint[];
  hasDataColumns?: boolean;
  edgeGatewaySerialNumber?: string;
  loading?: boolean;
  physicalModelId?: React.Key;
  isBatch?: boolean;
}

const SharedEdgeTemplateFormDetail: React.FC<SharedEdgeTemplateDetailProps> = ({
  data,
  dataSource,
  hasDataColumns,
  edgeGatewaySerialNumber,
  loading,
  physicalModelId,
  isBatch,
}) => {
  const pagingInfo = usePaging(10000);
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;
  const [searchParams, setSearchParams] = useState<SearchParams>();
  const { isGateway } = useIsGateway(data?.deviceTypeId);
  const FormDisplay = data?.iotProtocol !== undefined ? formItemsDisplayByType[data?.iotProtocol] : undefined;

  const _data = useMemo(() => {
    let _dataSource = dataSource;
    if (data?.iotProtocol === IotProtocolType.MOCKINGBIRD) {
      _dataSource = dataSource.filter(item => (item as any).pointType === searchParams?.pointType);
    }
    setTotalCount(_dataSource.length);
    return _dataSource
      .filter(item =>
        !searchParams?.name
          ? true
          : item.dataPropertyName?.includes(searchParams?.name) || item.identifier?.includes(searchParams?.name)
      )
      .slice(pageSize * (pageOffset - 1), pageOffset * pageSize);
  }, [dataSource, pageOffset, pageSize, searchParams, setTotalCount, data?.iotProtocol]);

  useEffect(() => {
    setPageOffset(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams?.pointType]);

  return (
    <>
      <SubContent title="设备数采信息">
        <Form layout="vertical">
          <BaseInfoContent>
            <Form.Item name="edgeGatewaySerialNumber" label="关联网关">
              {edgeGatewaySerialNumber ? (
                <>
                  {edgeGatewaySerialNumber}&nbsp;
                  <Typography.Link>
                    <Link target="_blank" to={`/device/config/gateway?serialNumber=${edgeGatewaySerialNumber}`}>
                      查看网关
                    </Link>
                  </Typography.Link>
                </>
              ) : (
                '--'
              )}
            </Form.Item>
            <Form.Item name="edgeDeviceTemplateName" label="数采模板">
              {data?.edgeDeviceTemplateName ?? '--'}
            </Form.Item>
            <Form.Item name="edgeDeviceTemplateVersion" label="版本号">
              {data?.edgeDeviceTemplateVersion ?? '--'}
            </Form.Item>
            <Form.Item name="edgeDeviceTemplateLatestVersion" label="最新版本号">
              {data?.edgeDeviceTemplateLatestVersion ?? '--'}
            </Form.Item>
            <Form.Item name="edgeDeviceTemplateVersionRemark" label="版本备注">
              {data?.edgeDeviceTemplateVersionRemark ? data.edgeDeviceTemplateVersionRemark : '--'}
            </Form.Item>
            {data?.iotProtocol === IotProtocolType.MOCKINGBIRD && !isGateway && FormDisplay && (
              <FormDisplay data={data} />
            )}
          </BaseInfoContent>
        </Form>
        {data && (
          <>
            <EdgeDevicePointDetail
              type={data.iotProtocol}
              dataSource={_data}
              loading={loading}
              info={{
                iotProtocol: data.iotProtocol,
                driveType: data.driveType,
                deviceTypeId: data.deviceTypeId,
                physicalModelId,
              }}
              isBatch={isBatch}
              setSearchParams={setSearchParams}
              hasDataColumns={hasDataColumns}
            />
            {/* <Paging pagingInfo={pagingInfo}/> */}
          </>
        )}
      </SubContent>
    </>
  );
};

export default SharedEdgeTemplateFormDetail;
